import { render } from "./dispatch.vue?vue&type=template&id=ff736340&scoped=true&ts=true"
import script from "./dispatch.vue?vue&type=script&lang=ts"
export * from "./dispatch.vue?vue&type=script&lang=ts"

import "./dispatch.vue?vue&type=style&index=0&id=ff736340&lang=stylus&scoped=true"

import exportComponent from "D:\\Front-end-project\\anxin-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff736340"]])

export default __exports__